<template>
  <div>
    <b-table :data="accesses" hoverable>
      <b-table-column field="createdAt" label="Data" v-slot="props">
        {{ moment(props.row.createdAt).format("DD/MM/YY HH:mm:ss") }}
      </b-table-column>

      <b-table-column
        field="device.store.storeInfo.name"
        label="Loja"
        v-slot="props"
      >
        {{ props.row.device.store.storeInfo.name }}
      </b-table-column>

      <b-table-column
        field="user.personalInfo.name"
        label="Cliente"
        v-slot="props"
      >
        <div v-if="props.row.user">
          <button
            class="button is-light"
            slot="trigger"
            v-if="
              props.row.user.personalInfo &&
              (props.row.user.personalInfo.personalId ||
                props.row.user.personalInfo.email ||
                props.row.user.personalInfo.cellphone)
            "
            @click.stop="openUserInfoModal(props.row.user)"
          >
            {{
              `${props.row.user.personalInfo.name} ${props.row.user.personalInfo.surname}`
            }}
          </button>

          <p v-else>
            {{ props.row.user._id }}
          </p>
        </div>

        <div v-else>Teste / Manutenção</div>
      </b-table-column>

      <b-table-column field="device.deviceModel" label="Modelo" v-slot="props">
        {{
          props.row.device && props.row.device.deviceModel
            ? props.row.device.deviceModel
            : "-"
        }}
      </b-table-column>

      <b-table-column field="readAt" label="Lido" v-slot="props">
        {{
          props.row.readAt
            ? moment(props.row.readAt).format("DD/MM/YY HH:mm:ss")
            : "-"
        }}
      </b-table-column>

      <b-table-column field="authorized" label="Autorizado" v-slot="props">
        {{
          props.row.authorized === true
            ? "Sim"
            : props.row.authorized === false
            ? "Não"
            : "-"
        }}
      </b-table-column>

      <b-table-column field="suspect" label="Suspeito" v-slot="props">
        <span
          :class="[
            'tag',
            isAccessSuspect(props.row) ? 'is-warning' : 'is-light'
          ]"
        >
          {{ isAccessSuspect(props.row) ? "Sim" : "Não" }}
        </span>
      </b-table-column>

      <template slot="empty">
        <table-empty-template />
      </template>
    </b-table>

    <b-modal :active.sync="isUserInfoModalActive" has-modal-card>
      <user-info-modal :user="user" />
    </b-modal>
  </div>
</template>

<script>
import userInfoModal from "../common/UserInfoModal";
import tableEmptyTemplate from "../common/TableEmptyTemplate";

export default {
  props: ["accesses"],

  components: {
    userInfoModal,
    tableEmptyTemplate
  },

  data() {
    return {
      isUserInfoModalActive: false,
      user: null
    };
  },

  methods: {
    loading(event) {
      this.$emit("is-loading", event);
    },

    openUserInfoModal(user) {
      this.user = user;
      this.isUserInfoModalActive = true;
    },

    isAccessSuspect(access) {
      return access && typeof access.suspect === "boolean"
        ? access.suspect
        : access && access.authorized === true && access.paid === false;
    }
  }
};
</script>
